import { makeGetRequest } from 'owa-ows-gateway';
import { ActivityFeedResponse } from './ActivityFeedResponse';

const GET_ACTIVITY_FEED_URL: string = 'ows/beta/ActivityFeed';

export const getActivityFeed: () => Promise<ActivityFeedResponse> = () =>
    makeGetRequest(GET_ACTIVITY_FEED_URL);
